/** Stable handler for opening the image picker modal (avoids stale GrapesJS editor closures). */
let openBackgroundImagePickerHandler = null;

export function setBackgroundImagePickerHandler(handler) {
  openBackgroundImagePickerHandler = typeof handler === 'function' ? handler : null;
}

export function clearBackgroundImagePickerHandler() {
  openBackgroundImagePickerHandler = null;
}

/**
 * Open the shared image picker modal.
 *
 * @param {string} currentUrl
 * @param {(url: string) => void} onSelect
 * @param {{ title?: string }} [options] - extra display options forwarded to the modal
 * @returns {boolean} true if the modal was opened
 */
export function requestOpenBackgroundImagePicker(currentUrl, onSelect, options) {
  if (typeof openBackgroundImagePickerHandler !== 'function') {
    return false;
  }
  openBackgroundImagePickerHandler(currentUrl, onSelect, options || {});
  return true;
}
